import React, { useEffect } from "react";
import { inBodyInterviewMeasureItems } from "@icoach/inbody/interview/InBodyInterviewMeasureNormalBox";
import { Card, Stack, Typography } from "@curves/ui-base";
import { isEmpty } from "@util/utils";
import { MeasureRecordTable } from "@icoach/inbody/components";

const InBodyInterviewMeasureTable = React.forwardRef(({ sourceData: validMeasureData = [], getInterviewMeasureApi }, ref) => {
	useEffect(
		() => {
			getInterviewMeasureApi();
		},
		// eslint-disable-next-line
		[]
	);

	return (
		<Card>
			{!isEmpty(validMeasureData) ? (
				<Card.CardContent>
					<MeasureRecordTable sourceData={validMeasureData} measureItems={inBodyInterviewMeasureItems} />
				</Card.CardContent>
			) : (
				<Card.CardContent className={"p-3"}>
					<Stack justifyContent={"center"} alignItems={"center"}>
						<Typography variant="h6" className={"font-color-4"}>
							無相關資料
						</Typography>
					</Stack>
				</Card.CardContent>
			)}
		</Card>
	);
});

export default InBodyInterviewMeasureTable;
